
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.992.75c.151 0 .29.036.414.11.13.067.232.169.305.304.078.135.117.29.117.461 0 .172-.039.326-.117.46a.766.766 0 01-.305.313.855.855 0 01-.414.102.9.9 0 01-.422-.102.837.837 0 01-.304-.312.957.957 0 01-.11-.461c0-.172.037-.326.11-.46A.779.779 0 014.57.858.85.85 0 014.992.75zm0 5.602c.151 0 .29.036.414.109.13.068.232.17.305.305.078.135.117.289.117.46 0 .172-.039.326-.117.462A.766.766 0 015.406 8a.855.855 0 01-.414.102A.9.9 0 014.57 8a.837.837 0 01-.304-.313.957.957 0 01-.11-.46c0-.172.037-.326.11-.461a.779.779 0 01.304-.305.85.85 0 01.422-.11zM.164 4.945V3.906H9.79v1.04H.164z","fill":"currentColor"}})])
          )
        }
      }
    